import React from 'react';
import { Button } from 'ui';
import trackEvent from 'misc/trackEvent';
import Popover from 'components/shared/popover';
import DefaultViewProvider from './DefaultViewProvider';

const OptionsPopover = ({ onDismiss }) => (
  <Popover position="right" dismissCallback={onDismiss}>
    <div className="mb-16">
      <h4 className="fw-b ff-ss d-ib">
        {I18n.t('default_content_view.title')}
      </h4>
    </div>
    <p className="c-gray-dark">{I18n.t('default_content_view.description')}</p>
    <DefaultViewProvider>
      {({ currentView, viewTypes, save, revert }) => (
        <div>
          <Button
            small
            icon="save"
            className="mb-8"
            onClick={() => {
              trackEvent('default_content_view/save_default_view_clicked', {
                location: 'Content Page - Save Default Experiment',
              });
              save().then(onDismiss);
            }}
            disabled={currentView === viewTypes.SET}
          >
            {I18n.t('default_content_view.save')}
          </Button>
          <Button
            small
            icon="undo"
            onClick={() => {
              trackEvent('default_content_view/revert_default_view_clicked', {
                location: 'Content Page - Revert Default Experiment',
              });
              revert().then(onDismiss);
            }}
            disabled={
              currentView === viewTypes.UNSET || currentView !== viewTypes.DIRTY
            }
          >
            {I18n.t('default_content_view.revert')}
          </Button>
        </div>
      )}
    </DefaultViewProvider>
  </Popover>
);

export default OptionsPopover;
